import { render, staticRenderFns } from "./SalonsScreen.vue?vue&type=template&id=1d8dd03a"
import script from "./SalonsScreen.vue?vue&type=script&lang=js"
export * from "./SalonsScreen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports